import React from 'react';
import '../style/cookies.css';


export default function DemoInfo(props) {
  return (
    <div className="demoInfo_container">
            <span
                style={{position: 'absolute', top: '2vh', left: '2vw'}}>
                <img src={process.env.PUBLIC_URL + '/icons/logo_clown.png'} width="50" height="50" alt="logo"/>
            </span>
        <div
            className="cookies_title"
            style={{
                height: '15vh',
                marginTop: '8vh',
                minHeight: '100px', 
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
            <h1
                style={{
                    color: 'black',
                    fontFamily: '"Klee One", cursive',
                }}>Welcome on the <b>Artsit's website</b></h1>
        </div>
        <div>
            <a
                href="https://www.pascalcosta.fr"
                target="_blank" 
                style={{
                    textDecoration: 'none',
                    color: 'yellow',
                    fontSize: '12px',
                }} rel="noreferrer">Build by Pascal Costa</a>
        </div>
        <hr style={{width: '65vw'}}></hr>
        <div
            style={{
                marginTop: '5vh',
                height: '18vh',
                minHeight: '120px', 
                width: '100vw',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
            <p
                style={{
                    padding: '0 25px 0 15px',
                    height: '20vh',
                    maxWidth: '500px',
                    fontSize: '18px',
                    textAlign: 'justify',
                    color: 'black',
                    fontFamily: '"Klee One", cursive',
                }}>
                <span style={{marginLeft: '30px'}}></span>Hello and welcome to this model from the artist's website. 
                You can imagine your personalized 
                version with your menus, your texts and your photos.
            </p>
        </div>
        <div
            style={{
                marginTop: '5vh',
                height: '18vh',
                minHeight: '100px', 
                width: '100vw',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
            <p
                style={{
                    padding: '0 25px 0 15px',
                    height: '25vh',
                    maxWidth: '500px',
                    fontSize: '18px',
                    textAlign: 'justify',
                    color: 'black',
                    fontFamily: '"Klee One", cursive',
                    }}>
                <span style={{marginLeft: '30px'}}></span>You will discover the artist's website. This is a demo version none of the 
                information is real, and you will not be able to view any data.
            </p>
        </div>
        <hr style={{width: '65vw'}}></hr>
        <div
            style={{
                marginTop: '5vh'}}>
            <button 
                className="validate_cookies"
                style={{
                    background: 'lightyellow',
                    border: '3px solid yellow',
                    fontSize: '32px',
                    fontFamily: '"Klee One", cursive',
                }}
                onClick={() => setTimeout(() => props.setDemoInfoDisplay(false))}>
                    Go !
                </button>
        </div>
    </div>
  )
}
